export default __webpack_public_path__ + "static/media/twitter.3739c115.svg";